import { call, put, select, takeLatest } from 'redux-saga/effects';

import { SELECT_DEALER } from 'constants/ActionTypes';
import { PATH } from 'constants/RoutesConstants';
import { scopeToPage } from 'modules/app/sagas/utils';
import * as actions from 'modules/gates/actions/core';
import * as types from 'modules/gates/actionTypes';
import { getFormattedFilters } from 'modules/gates/selectors/dashboard';

import { GATE_DASHBOARD } from '../constants';

function* refreshGatesDashboard() {
  const params = yield select(getFormattedFilters);
  yield put(actions.fetchGates(params, { target: GATE_DASHBOARD }));
}

const REFRESH_ACTIONS = [SELECT_DEALER, types.SET_GATES_DASHBOARD_FILTER, types.CLEAR_GATES_DASHBOARD_FILTER];

function* onPageWorker() {
  yield call(refreshGatesDashboard);
  yield takeLatest(REFRESH_ACTIONS, refreshGatesDashboard);
}

export default function* gateDashboardSaga() {
  yield scopeToPage([PATH.GATE_MANAGEMENT_DASHBOARD], onPageWorker);
}
